import styled from "styled-components/macro";

export const StyledContainer = styled.div`
  height: 100%;
  overflow-y: hidden;
  overscroll-behavior: contain;
  border-radius: 12px;

  .title {
    font-size: 1rem;
    margin-bottom: 1rem;
    color: var(--primary-cta-hover);
    font-weight: 600;
    text-align: center;
  }

  .type {
    text-align: center;
    width: 250px;
    margin: auto auto 2rem auto;
    z-index: 8000000000;

    a {
      font-size: 20px;
      border: 1px solid var(--primary-cta);
      padding: 5px 10px;
      border-radius: 5px;

      &:hover {
        background: var(--text-highlight);
      }
    }

    svg {
      margin-left: 5px;
      fill: var(--primary-cta);
      width: 12px;
      height: 12px;
    }

    /*  */
  }

  textarea.editable {
    border: 1px solid var(--grey-2);
    border-radius: 3px;
    margin: 0;
    padding: 0.25rem;
    font-size: 1.2rem;
    line-height: 1.5em;
    font-family: Inter;
    width: 100%;
    text-align: left;
    display: block;
    text-align: left;
    outline: none;
    background: var(--menu-color);
    resize: none;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    cursor: pointer;
    color: var(--icon-button-fill);
    overflow-y: scroll;

    &:disabled {
      background: none;
    }
  }

  button:disabled {
    background-color: var(--button-disabled) !important;
    cursor: default !important;
    color: var(--button-disabled-color) !important;
  }

  .submit {
    margin: 0.5rem auto auto auto;
    text-align: center;
  }
`;
